export default "__VITE_ASSET__1fdHveaT__"